module.exports = __webpack_public_path__ + "img/stripe.9f2948e6.jpg";